const React = require("react");
const adminCtor = require("./adminCtor");
const merchantCtor = require("./merchantCtor");
const toEllipsisMiddle = require("../../../../utils/toEllipsisMiddle");
const getExplorerUrlPrefixByCoin = require("../../../../utils/getExplorerUrlPrefixByCoin");
const getExplorerUrlPostfixByCoin = require("../../../../utils/getExplorerUrlPostfixByCoin");

const displayHashTitle = ({hash}) => hash;
const displayHashData = (className) => ({symbol, network, hash, disabledEllipsedMode}) => {
  if (!hash) return '';

  if (hash.includes('Off-chain transfer')) return hash;

  let prefix = '';
  let postfix = '';

  if (symbol || network) {
    prefix = getExplorerUrlPrefixByCoin(network || symbol) || '';
    postfix = getExplorerUrlPostfixByCoin(network || symbol) || '';
  }

  const value = disabledEllipsedMode ? hash : toEllipsisMiddle(hash, 20);

  return prefix
    ? (
      <a
        className={`olN` + (className ? ` ${className}` : '')}
        href={prefix + hash + postfix}
        target="_blank"
        rel="noopener noreferrer"
        title="See transaction details on external blockchain explorer"
      >{value}</a>
    ) : value;
}

const basicProps = {titleHandler: displayHashTitle, hasCustomData: true}

const displayHashAdmin = adminCtor({...basicProps, dataHandler: displayHashData('cDADCE1')});
const displayHashMerchant = merchantCtor({...basicProps, dataHandler: displayHashData('tdN c5B47FF')});

module.exports = {
  displayHashAdmin,
  displayHashMerchant
};
